export default __webpack_public_path__ + "static/media/misc-closet2-1024w.c1003feb.avif";